// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"a5b2ad55","831":"a5b2ad55"}[chunkId] + ".chunk.css";
};